import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone.js'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.extend(timezone)

const BRISBANE_TZ = 'Australia/Brisbane'

export const toTimezone = (dateString: string | Date): string => dayjs(dateString).tz(BRISBANE_TZ).format('DD-MMM-YYYY')

export const toFullTimezone = (dateString: string | Date): string =>
  dayjs(dateString).tz(BRISBANE_TZ).format('DD-MMM-YYYY HH:mm:ss')
